// extracted by mini-css-extract-plugin
export default {"sidebar":"LabelingSidebar_sidebar__1RlBy"};